import {
  FETCH_DATA_RESET,
  FETCH_FILE,
  FETCH_FILE_FAILED,
  FETCH_FILE_SUCCESS,
} from "./actionType";
import axios from "axios";

// const baseURL = "https://ld8ms8qt-7070.inc1.devtunnels.ms/";
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const fetchFile = (data) => async (dispatch) => {
  try {
    dispatch({
      type: FETCH_FILE,
    });
    dispatch({
      type: FETCH_DATA_RESET,
      payload: null,
    });
    const url = `${baseURL}file-fetch?cycleNo=${data.cycleNo}&date=${
      data.date
    }${data?.fileType ? `&fileType=${data?.fileType}` : ""}${data?.billerId?`&billerId=${data?.billerId}`:""}`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "69420",
      },
    });

    // Check for a successful response
    if (response.status >= 200 && response.status < 400) {

      dispatch({ type: FETCH_FILE_SUCCESS, payload: response.data });
    } else {
      dispatch({
        type: FETCH_FILE_FAILED,
        payload: response.statusText || "something went wrong",
      });
    }
  } catch (error) {
    // Handle error message more clearly
    if (error.response && error.response.data && error.response.data.message) {
      dispatch({
        type: FETCH_FILE_FAILED,
        payload: error.response.data.message,
      });
    } else {
      dispatch({
        type: FETCH_FILE_FAILED,
        payload: error,
      });
    }

    // dispatch({ type: FETCH_DATA_RESET });
    console.error("Error in fetching file:", error);
  }
};
